import classnames from 'classnames';

import './style.scss';

const PREFIX = 'music';

export type ReleaseStateType = 'published' | 'review' | 'rejected';

export interface ReleaseStateProps {
  /** 状态类型 */
  state: ReleaseStateType;
  /** 自定义类名 */
  className?: string;
}

const STATE_CONFIG: Record<ReleaseStateType, { label: string; colorClass: string }> = {
  published: { label: 'Released', colorClass: 'success' },
  review: { label: 'Under Review', colorClass: 'warning' },
  rejected: { label: 'Rejected', colorClass: 'error' },
};

export default function ReleaseState({ state, className }: ReleaseStateProps) {
  const config = STATE_CONFIG[state];
  
  return (
    <div className={classnames(`${PREFIX}-release-state`, className)}>
      <span className={classnames(`${PREFIX}-release-state__dot`, `${PREFIX}-release-state__dot--${config.colorClass}`)} />
      <span className={`${PREFIX}-release-state__text`}>{config.label}</span>
    </div>
  );
}
